import {
  collection,
  doc,
  QueryDocumentSnapshot,
  Timestamp,
} from "firebase/firestore";

import { db } from "integrations/firebase/firestore";
import { FirestoreAcpExport } from "reedy-data/models";

interface FirestoreAcpExportFromFirebase
  extends Omit<FirestoreAcpExport, "createdAt" | "updatedAt"> {
  createdAt: Timestamp | null;
  updatedAt: Timestamp | null;
}

export interface FirestoreAcpExportWithId extends FirestoreAcpExport {
  id: string;
}

const acpExportConverter = {
  toFirestore: (acpExport: FirestoreAcpExportWithId) => {
    // biome-ignore lint/correctness/noUnusedVariables: drops id before the document is written to Firestore
    const { id, ...rest } = acpExport;
    return rest;
  },
  fromFirestore(
    snapshot: QueryDocumentSnapshot<FirestoreAcpExportFromFirebase>,
  ): FirestoreAcpExportWithId {
    const data = snapshot.data();

    return {
      ...data,
      createdAt: data.createdAt?.toDate() || undefined,
      updatedAt: data.updatedAt?.toDate() || null,
      id: snapshot.id,
    };
  },
};

export const getAcpExportsCollection = () =>
  collection(db, "acpExports").withConverter(acpExportConverter);

export const getAcpExportDocument = (id: string) =>
  doc(db, "acpExports", id).withConverter(acpExportConverter);
